import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ValidatorService} from '../core/validator/validator.service';
import {CrawlerService} from '../core/ecv-http-services/services/crawler.service';
import {CustomValidators} from '../core/validator/custom-validators';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';


@Component({
  selector: 'app-web-search',
  templateUrl: './web-search.component.html'
})

export class WebSearchComponent implements OnInit {
  webSearchForm: FormGroup;
  requiredText: string;
  urlsResult: string[];

  constructor(private validatorService: ValidatorService,
              private crawlerService: CrawlerService,
              private spinnerService: Ng4LoadingSpinnerService) {
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.webSearchForm = new FormGroup({
      'web-search': new FormControl('', CustomValidators.notEmpty)
    });
  }

  loadData() {
    this.validatorService.validate(this.webSearchForm);
    if (!this.validatorService.isValid(this.webSearchForm)) {
      return;
    }
    this.spinnerService.show();
    this.crawlerService.searchUrlsInCrawler(this.requiredText).subscribe(response => {
      this.urlsResult = response.result;
      this.spinnerService.hide();
    }, error => {
      this.spinnerService.hide();
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/web-search/web-search.component.ts